export const LOGIN_ROUTE = "/vendor";
export const DASHBOARD_ROUTE = "/vendor/dashboard";
export const FORGOT_ROUTE = "/vendor/forgot-password";

export const OTP_ROUTE = "/vendor/otps";
export const PROFILE_ROUTE = "/vendor/otps";
export const ORDER_ROUTE = "/vendor/orders";

export const VENDOR_PRODUCT_ROUTE = "/vendor/products";

export const VENDOR_MANAGER_ROUTE = "/vendor/vendor-managers";



export const MENU_PRICE = "/vendor/menu-pricing";
export const EXCEL_PRODUCT = "/vendor/excel-products";
export const GALLERY_ROUTE ="/vendor/gallery"
export const VENDOR_COMPLIANCE_ROUTE ="/vendor/vendor-compliance"
export const CAFETERIA_INVENTORY_ROUTE ="/vendor/cafeteria-inventory"

export function  PRODUCT_BY_EXCEL(id){
   return `/vendor/excel-products/${id}`;
}




